import React from "react";


function Box2(){
    return(
        <div>
            <div className="box2"> </div>
        </div>
    )
}

export default Box2;